import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { colorPalette } from '../styles/styleGuide';
import ImageLoader from './shared/ui/ImageLoader';
var BREAKPOINT = 380;
var HeroFlex = /*#__PURE__*/function (_Component) {
  function HeroFlex() {
    var _this;
    _classCallCheck(this, HeroFlex);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HeroFlex, [].concat(args));
    _defineProperty(_this, "state", {
      renderWidth: 0
    });
    return _this;
  }
  _inherits(HeroFlex, _Component);
  return _createClass(HeroFlex, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        renderWidth = _this$props.renderWidth,
        heroTriangleSmallColor = _this$props.heroTriangleSmallColor,
        heroTriangleLargeColor = _this$props.heroTriangleLargeColor,
        desktopImage = _this$props.desktopImage,
        mobileImage = _this$props.mobileImage;
      return __jsx(View, {
        size: renderWidth > BREAKPOINT ? 'large' : 'small',
        "data-id": "components_HeroFlex_View"
      }, __jsx(ImageLoader, {
        src: renderWidth > BREAKPOINT ? desktopImage || '' : mobileImage || '',
        mode: "bg",
        width: renderWidth,
        "data-id": "components_HeroFlex_ImageLoader"
      }), __jsx(Triangle, {
        height: "58%",
        width: "100%",
        viewBox: "0 0 203 203",
        preserveAspectRatio: "xMaxYMin",
        "data-id": "components_HeroFlex_Triangle"
      }, __jsx("polygon", {
        opacity: "0.5",
        fill: heroTriangleSmallColor || colorPalette.lightGreen,
        transform: "translate(101.500000, 101.500000) scale(1, -1) translate(-101.500000, -101.500000)",
        points: "203 0 203 203 0 203",
        "data-id": "components_HeroFlex_polygon"
      })), __jsx(Triangle, {
        height: "100%",
        width: "100%",
        viewBox: "0 0 349 349",
        preserveAspectRatio: "xMaxYMax",
        "data-id": "components_HeroFlex_Triangle"
      }, __jsx("polygon", {
        opacity: "0.75",
        fill: heroTriangleLargeColor || colorPalette.lightGreen,
        points: "349 0 349 349 0 349",
        "data-id": "components_HeroFlex_polygon"
      })));
    }
  }]);
}(Component);
var View = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-sizing: border-box;\n  padding-top: ", ";\n  width: 100%;\n  position: relative;\n\n  > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"])), colorPalette.lightGrey, function (props) {
  return props.size === 'large' ? '24.3%' : '78%';
});
var Triangle = styled.svg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 2;\n"])));
export default HeroFlex;